import { post } from '@/utils/axios'

class ResourceModel {

    /**
     * 官网获取内容下载
     * @param type 类型（0图片；1视频）
     * @param startPage 第几页
     * @param pageSize 一页数量
     * @returns {Promise<*>}
     */
    async getImageOrVideo(type = 1, startPage = 1, pageSize = 20) {
        return post('/v1/resource/getImageOrVideo',{
            type, startPage, pageSize
        })
    }

}

export default new ResourceModel()
